import { forwardRef } from "react";

import { t } from "i18n/i18n";
import { Button, type ButtonProps } from "mds/components/Button";
import { CrossRemoveIcon } from "mds/icons";

export const CloseButton = forwardRef<HTMLButtonElement, ButtonProps<"button">>(
  ({ kind = "white", size = "xs", title = t("common.close"), ...props }, ref) => (
    <Button kind={kind} ref={ref} size={size} title={title} isSquare {...props}>
      <CrossRemoveIcon />
    </Button>
  ),
);

CloseButton.displayName = "CloseButton";
